
import { getFileUploadURL } from '@/utils/constant'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'baseUploader'
})
export default class extends Vue {
  @Prop({ required: true }) private logo!: string
  private apiUrl: string = getFileUploadURL() + '/upload-file'

  get language() {
    return AppModule.language
  }

  private handleAvatarSuccess(res, file) {
    this.$emit('uploadOk', res.file_path)
  }

  private beforeAvatarUpload(file) {
    const isLt5M = file.size / 1024 / 1024 < 5
    if (!isLt5M) {
      this.$message.error('File size should not exceed 5MB!')
    }
    return isLt5M
  }

  mounted() {}
}
